import * as React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';

interface SummaryStepFragmentProps {
  isValid: boolean;
  showNotObligatoryIcon?: boolean;
}

const SummaryStepFragment: React.SFC<SummaryStepFragmentProps> = (props) => {
  let defaultIcon = <Icon iconType="Summering_OK25px25px" />;

  if (props.showNotObligatoryIcon) {
    defaultIcon = <Icon iconType="fontawesome/exclamation-circle" className="form-summary__missing" />;
  }

  const icon = props.isValid ? (
    defaultIcon
  ) : (
    <Icon iconType="Summering_inte_OK25px25px" className="form-summary__not-valid" />
  );

  return (
    <li className="form-summary__list-item">
      {icon}
      {props.children}
    </li>
  );
};

export default SummaryStepFragment;
